const token = localStorage.getItem("userToken");

const removeTokenFromLocalStorage = () => {
  localStorage.clear();
};

export { token, removeTokenFromLocalStorage };
